import * as React from "react";
import styled, { css } from "../../../styled/index";

const stopPropagation = (e: React.MouseEvent<HTMLElement>) => e.stopPropagation();

const SwitchWrapper = styled("div")<{ inline?: boolean }>`
  position: relative;
  label {
    font-weight: 400;
    cursor: pointer;
    display: inline-block;
  }
`;

const SwitchInput = styled("input")`
  visibility: visible;
  position: absolute;
  opacity: 0;
  margin-left: -9999px;
  visibility: hidden;
`;

const SwitchLabel = styled("label")<{ checked: boolean }>`
    display: block;
    position: relative;
    cursor: pointer;
    outline: none;
    user-select: none;
    margin: 0;
    padding: 2px;
    width: 50px;
    height: 24px;
    border-radius: 30px;
    background-color: #dddddd;
    transition: background 0.4s;
    &:before, &:after {
      display: block;
      position: absolute;
      content: "";
    }
    &:before {
      top: 2px;
      left: 2px;
      bottom: 2px;
      right: 2px;
      background: ${({theme}) => theme.input.background};
      border-radius: 30px;
      transition: background 0.4s;
    }
    &:after {
      top: 4px;
      left: 4px;
      bottom: 4px;
      background-color: #dddddd;
      border-radius: 30px;
      transition: margin 0.4s, background 0.4s;
      width: 16px;
    }
    ${(props) => props.checked ? css`
      background: ${props.theme.colors.primary};
      &:after {
        margin-left: 26px;
        background-color: ${props.theme.colors.primary};
      }
    ` : ""}
`;

export interface SwitchProps {
  id: string;
  name?: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => any;
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
  labelProps?: React.LabelHTMLAttributes<HTMLLabelElement>;
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>;
}

export const Switch = (props: SwitchProps) => (
  <SwitchWrapper onClick={stopPropagation} {...props.wrapperProps}>
    <SwitchInput
      type="checkbox"
      id={props.id}
      name={props.name}
      onChange={props.onChange}
      checked={props.checked}
      {...props.inputProps}
    />
    <SwitchLabel
      htmlFor={props.id}
      checked={props.checked}
      {...props.labelProps}/>
  </SwitchWrapper>
);
